import { render, staticRenderFns } from "./BtnInfo.vue?vue&type=template&id=712e97ff&scoped=true"
import script from "./BtnInfo.vue?vue&type=script&lang=js"
export * from "./BtnInfo.vue?vue&type=script&lang=js"
import style0 from "./BtnInfo.vue?vue&type=style&index=0&id=712e97ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e97ff",
  null
  
)

export default component.exports